/**
 * 【KYMW1407】画像情報管理使用停止更新
 *
 * @export UpdateImageInfoEnabledModel
 * @class UpdateImageInfoEnabledModel
 */
export class UpdateImageInfoEnabledModel {
  // 画像ID
  public imageId = String('');
}
